export default "__VITE_ASSET__763730f6__"